module.exports = __webpack_public_path__ + "img/P150T_weapon_82.5effbf7c.png";